// extracted by mini-css-extract-plugin
export default {"white":"#ffffff","mischka":"#d0d5dd","oxfordBlue":"#344054","Lato":"Lato, Helvetica, Arial, sans-serif","button":"styles_button__TUvJf","group":"styles_group__aMMdY"};